module.exports = __webpack_public_path__ + "static/media/Hi-flier-man.25aa840d.png";